<app-header></app-header>

<div class="page-title-area page-title-bg1">
    <div class="container">
        <div class="page-title-content">
            <h2>Help Center</h2>
        </div>
    </div>
</div>

<app-process></app-process>

<app-video></app-video>

<app-partner></app-partner>